/**
 * App-level View — delegates to @visioni/a3s-ui.
 */
export { View, View as ThemedView, type ViewProps } from "@visioni/a3s-ui/components";
